// TO'LIQ kelgan ro'yxat ustida qidiruv, filtr va saralash.
//
// ⛔ SAHIFALASH YO'Q VA BO'LMAYDI. Egasi qarori (2026-08-20):
// «Backenddan to'liq ro'yxat olib, uida ko'zbo'yamachilik uchun
// pagination qilma.» Shuning uchun bu modul `slice(page * size, ...)` ni
// UMUMAN bilmaydi — argumentlari orasida sahifa raqami ham, hajmi ham
// yo'q. Sahifalanadigan endpoint uchun `DataTable` bor.
//
// ⚠️ NEGA MIJOZDA SARALASH BU YERDA YOLG'ON EMAS. `JADVAL-QOIDASI` §2
// mijozda saralashni taqiqlaydi, sababi — u FAQAT JORIY SAHIFANI
// saralaydi. Bu modul chaqiruvchilarida sahifa tushunchasining O'ZI yo'q:
// quyidagi endpointlarning birortasida `page`/`size` parametri yo'q:
//   GET /api/hr/job-titles, /api/hr/leave-types, /api/hr/pay-components
//   GET /api/inventory/stock/{balances,approvals}
//   GET /api/finance/accounts        (faqat `activeOnly`)
//   GET /api/finance/periods         (parametrsiz)
//   GET /api/finance/reports/{trial-balance,branches,income-statement}
//   GET /api/reports/revenue/by/{dimension}
//   GET /api/reports/subscriber-movement    (faqat `from`/`to`)
// Ya'ni saralanadigan massiv — to'liq ro'yxatning O'ZI.
//
// ⚠️ RO'YXAT ESKIRADI — VA U BIR MARTA ESKIRGAN. 2026-08-20 da backend
// yettita ro'yxat endpointini sahifalangan shaklga o'tkazdi va
// `/api/inventory/stock/items` shu ro'yxatdan CHIQDI (`StockItemsPage`
// endi `DataTable` da). O'sha kuni bu izoh «backend kodidan
// tekshirilgan, taxmin emas» deb turardi va aynan shu ishonch uni
// KO'RSATMA qilib qo'ygan edi — kimdir uni o'qib, sahifani mijozda
// qoldirishi mumkin edi. Shuning uchun: ro'yxat DALIL EMAS, chaqiruvchi
// har safar o'z endpointini tekshirsin. Sahifalangan endpointga bu
// modulni ulash TAQIQ.
//
// ⚠️ Shuning uchun bu modulni SAHIFALANADIGAN ro'yxatga ulash TAQIQ:
// o'sha holatda u aynan `JADVAL-QOIDASI` ogohlantirgan yolg'on tartibni
// beradi.
//
// ⚠️ Hisobot yakunlari (`totalDebitMinor`, `company`, `total`) SERVERDAN
// keladi va filtrga BOG'LIQ EMAS: filtr qo'yilganda jadval qisqaradi,
// yakun esa o'zgarmaydi. Buni aytmaslik «filtrlangan yakun» degan yolg'on
// o'qishga olib borardi — `ReportFilterBar` shu izohni chizadi.

import { useCallback, useEffect, useMemo, useState } from 'react'
import type { TableProps } from 'antd'
import type { SorterResult } from 'antd/es/table/interface'
import { useTableUrlState } from '@/shared/ui/table/useTableUrlState'
import type { SortOrder, TableState } from '@/shared/ui/table/tableState'

export interface LocalSort {
  field: string
  order: SortOrder
}

/** `DataTable` dagi bilan AYNI qiymat — qidiruv butun panelda bir tezlikda */
export const SEARCH_DEBOUNCE_MS = 350

export interface LocalListStateOptions {
  /**
   * Saralash TANLANMAGANDA qo'llanadigan tartib.
   *
   * ⚠️ Egasi talabi: «Oxirgi qo'shilgan doim birinchi chiqishi kerak».
   * Qatorda yaratilish vaqti UMUMAN bo'lmasa (`StockBalance` da yo'q)
   * `null` beriladi va server tartibi saqlanadi — o'ylab topilgan tartib
   * qo'yilmaydi.
   */
  defaultSort?: LocalSort | null
  /**
   * Qaysi filtr kalitlari ro'yxatni TORAYTIRADI.
   *
   * ⚠️ Hisobot ekranlarida URL'da filtrdan tashqari KONTEKST ham saqlanadi
   * (qaysi kun, qaysi kesim, qaysi xodim). U ro'yxatni toraytirmaydi —
   * savolning O'ZINI belgilaydi. Hammasini bir xil sanash «Tozalash»
   * tugmasini DOIM ko'rsatardi va operator ro'yxat filtrlangan deb
   * o'ylardi. Berilmasa — barcha filtr kalitlari sanaladi.
   */
  narrowingKeys?: readonly string[]
  /** Bitta sahifada bir nechta ro'yxat bo'lsa — URL parametr prefiksi */
  prefix?: string
}

export interface LocalListState {
  state: TableState
  patch: (partial: Partial<TableState>) => void
  /** Qidiruv, filtr va saralashni tozalaydi */
  reset: () => void

  /** Maydonga yozilayotgan matn (kechikishsiz) */
  searchText: string
  setSearchText: (value: string) => void
  /** URL'ga yozilgan, kechikish o'tgan qidiruv — filtrlash SHUNI oladi */
  search: string

  /** Ustun kaliti → tanlangan qiymatlar; bo'sh massiv saqlanmaydi */
  values: Readonly<Record<string, readonly string[]>>
  setValues: (key: string, values: readonly string[]) => void
  /** Bitta qiymatli filtr o'qish/yozish (URL'da hammasi massiv) */
  filter: (key: string) => string | null
  setFilter: (key: string, value: string | null) => void

  /** Qo'yilgan filtrlar soni — qidiruv bunga KIRMAYDI */
  activeFilterCount: number
  /** Ro'yxatni TORAYTIRADIGAN biror shart bormi (qidiruv ham) */
  narrowed: boolean

  /** Amaldagi tartib: tanlangani, bo'lmasa standarti */
  sort: LocalSort | null
}

/**
 * Jadval holati — MANZILDA (`SubscriberFilterBar` bilan bir xil naqsh):
 * sahifa yangilanganda filtr yo'qolmaydi, havola ulashiladi va "orqaga"
 * tugmasi kutilganday ishlaydi. O'z `useState` i ikkinchi haqiqat manbai
 * bo'lardi.
 *
 * ⚠️ `page`/`size` bu yerda O'QILMAYDI: bu ro'yxatlar sahifalanmaydi.
 */
export function useLocalListState(options: LocalListStateOptions = {}): LocalListState {
  const { defaultSort = null, narrowingKeys, prefix } = options
  const { state, patch, reset: resetAll } = useTableUrlState(prefix === undefined ? {} : { prefix })

  // Har harfda URL yozish tarixga yozuv qo'shardi va «orqaga» tugmasi
  // o'nlab marta bosilishi kerak bo'lardi.
  const [searchText, setSearchText] = useState(state.search)
  useEffect(() => setSearchText(state.search), [state.search])
  useEffect(() => {
    if (searchText === state.search) return
    const timer = setTimeout(() => patch({ search: searchText }), SEARCH_DEBOUNCE_MS)
    return () => clearTimeout(timer)
  }, [searchText, state.search, patch])

  const setValues = useCallback(
    (key: string, values: readonly string[]) => {
      const next: Record<string, readonly string[]> = { ...state.filters }
      if (values.length === 0) delete next[key]
      else next[key] = values
      patch({ filters: next })
    },
    [state.filters, patch],
  )

  const filter = useCallback(
    (key: string): string | null => {
      const values = state.filters[key]
      return values && values.length > 0 ? (values[0] ?? null) : null
    },
    [state.filters],
  )

  const setFilter = useCallback(
    (key: string, value: string | null) => setValues(key, value === null ? [] : [value]),
    [setValues],
  )

  /**
   * «Tozalash» — faqat TORAYTIRUVCHI filtrlarni va qidiruvni oladi.
   *
   * ⚠️ Kontekst (qaysi kun, qaysi kesim) SAQLANADI: uni ham tozalash
   * operatorni ochgan hisobotidan uloqtirib yuborardi va u buni
   * "tozalash" tugmasidan kutmaydi.
   */
  const reset = useCallback(() => {
    if (narrowingKeys === undefined) {
      resetAll()
      return
    }
    const kept: Record<string, readonly string[]> = {}
    for (const [key, values] of Object.entries(state.filters)) {
      if (!narrowingKeys.includes(key) && values.length > 0) kept[key] = values
    }
    patch({ filters: kept, search: '', sortField: null, sortOrder: null })
  }, [narrowingKeys, resetAll, state.filters, patch])

  const activeFilterCount = Object.entries(state.filters).filter(
    ([key, values]) =>
      values.length > 0 && (narrowingKeys === undefined || narrowingKeys.includes(key)),
  ).length

  const sort = useMemo<LocalSort | null>(() => {
    if (state.sortField !== null && state.sortOrder !== null) {
      return { field: state.sortField, order: state.sortOrder }
    }
    return defaultSort
    // `defaultSort` chaqiruvchida literal obyekt bo'lishi mumkin —
    // maydonlari bo'yicha bog'lanadi, aks holda har chizishda yangi
    // havola kelib `useMemo` ma'nosini yo'qotardi.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.sortField, state.sortOrder, defaultSort?.field, defaultSort?.order])

  return {
    state,
    patch,
    reset,
    searchText,
    setSearchText,
    search: state.search.trim(),
    values: state.filters,
    setValues,
    filter,
    setFilter,
    activeFilterCount,
    narrowed: activeFilterCount > 0 || state.search.trim() !== '',
    sort,
  }
}

/**
 * antd ustuniga saralash bog'laydi.
 *
 * ⚠️ `sortOrder` MAJBURIY: manba haqiqat — URL, jadvalning ichki holati
 * emas. Busiz sahifa yangilangach tartib qo'llanadi, lekin sarlavhadagi
 * strelka uni ko'rsatmaydi.
 */
export function sortColumn(sort: LocalSort | null, key: string) {
  return {
    sorter: true as const,
    sortOrder: sort !== null && sort.field === key ? sort.order : null,
  }
}

/**
 * `<Table onChange>` — faqat saralashni URL'ga yozadi.
 *
 * ⚠️ Ustun voronkalari ISHLATILMAYDI: etalon jadvalda o'lchangan
 * ("ko'rinmagan boshqaruv mavjud emas bilan barobar"), shuning uchun
 * filtrlar ko'rinadigan tanlagichlarda va ular URL'ga o'zlari yozadi.
 */
export function localSortChange<T>(
  patch: (partial: Partial<TableState>) => void,
): NonNullable<TableProps<T>['onChange']> {
  return (_pagination, _filters, sorter) => {
    const single: SorterResult<T> | undefined = Array.isArray(sorter) ? sorter[0] : sorter
    const field = single?.order && single.columnKey !== undefined ? String(single.columnKey) : null
    const order: SortOrder | null = single?.order ?? null
    patch({ sortField: field, sortOrder: order })
  }
}

/**
 * Qidiruv matni maydonlarning BIRORTASIDA uchraydimi.
 *
 * ⚠️ Registr va chet bo'shliqlar e'tiborga olinmaydi: operator hisob
 * kodini «5010 » deb nusxalab qo'yishi odatiy hol va bunda natija bo'sh
 * chiqsa u «hisob yo'q» degan xulosaga kelardi.
 */
export function matchesSearch(
  search: string,
  ...fields: readonly (string | number | null | undefined)[]
): boolean {
  const needle = search.trim().toLocaleLowerCase()
  if (needle === '') return true
  return fields.some(
    (field) =>
      field !== null
      && field !== undefined
      && String(field).toLocaleLowerCase().includes(needle),
  )
}

/** Tanlangan qiymatlar ro'yxatiga tushadimi. Filtr bo'sh bo'lsa — hamma o'tadi. */
export function matchesValues(
  selected: readonly string[] | undefined,
  value: string | null | undefined,
): boolean {
  if (!selected || selected.length === 0) return true
  return value !== null && value !== undefined && selected.includes(value)
}

export interface LocalListOptions<T> {
  /** Kechikish o'tgan qidiruv matni */
  search: string
  /** Qatordan qidiriladigan matnlar — `null` maydonlar tashlab yuboriladi */
  searchFields?: (row: T) => readonly (string | number | null | undefined)[]
  /** Filtr kaliti → predikat. Kalit URL'dagi `f.<kalit>` bilan bir xil. */
  filters?: Readonly<Record<string, (row: T, value: string) => boolean>>
  filterState: Readonly<Record<string, readonly string[]>>
  /** Ustun kaliti → taqqoslagich (o'suvchi tartibda) */
  comparators?: Readonly<Record<string, (a: T, b: T) => number>>
  sort: LocalSort | null
}

/**
 * Qidiruv → filtr → saralash. Kirish massivi O'ZGARTIRILMAYDI.
 *
 * ⚠️ Noma'lum ustun bo'yicha saralash so'ralsa (masalan eski havola)
 * tartib TEGILMAYDI — jadval yiqilmaydi va server tartibi qoladi.
 */
export function applyLocalList<T>(
  rows: readonly T[],
  options: LocalListOptions<T>,
): readonly T[] {
  const { search, searchFields, filters, filterState, comparators, sort } = options

  let result = rows

  if (search.trim() !== '' && searchFields) {
    result = result.filter((row) => matchesSearch(search, ...searchFields(row)))
  }

  if (filters) {
    for (const [key, predicate] of Object.entries(filters)) {
      const values = filterState[key]
      const value = values && values.length > 0 ? values[0] : undefined
      if (value === undefined || value === '') continue
      result = result.filter((row) => predicate(row, value))
    }
  }

  if (sort && comparators) {
    const comparator = comparators[sort.field]
    if (comparator) {
      const sign = sort.order === 'descend' ? -1 : 1
      result = [...result].sort((a, b) => sign * comparator(a, b))
    }
  }

  return result
}

/**
 * ⚠️ `a < b` bilan solishtirish lotin bo'lmagan harflarni kod nuqtasi
 * bo'yicha tartiblardi va ro'yxat tasodifiy ko'rinardi.
 */
export function byText<T>(pick: (row: T) => string | null): (a: T, b: T) => number {
  return (a, b) => (pick(a) ?? '').localeCompare(pick(b) ?? '')
}

export function byNumber<T>(pick: (row: T) => number): (a: T, b: T) => number {
  return (a, b) => pick(a) - pick(b)
}

/** `null` — cheksiz (muddatsiz, kvotasiz): o'suvchi tartibda eng oxirida. */
export function byOptionalNumber<T>(pick: (row: T) => number | null): (a: T, b: T) => number {
  return (a, b) => {
    const left = pick(a)
    const right = pick(b)
    if (left === right) return 0
    if (left === null) return 1
    if (right === null) return -1
    return left - right
  }
}

/**
 * Vaqt bo'yicha taqqoslagich (o'suvchi: eskisi oldin).
 *
 * ⚠️ `null` — "server vaqtni bermadi", eng YANGI emas. Shunday qator
 * o'suvchi tartibda ENG ESKI o'rinni oladi, ya'ni standart
 * `createdAt descend` da ro'yxat OXIRIDA qoladi. Aks holda vaqti noma'lum
 * qatorlar "oxirgi qo'shilganlar" bo'lib ro'yxat boshini egallardi —
 * ishonarli ko'rinishda va tekshirib bo'lmaydigan holda.
 */
export function byInstant<T>(pick: (row: T) => string | null): (a: T, b: T) => number {
  return (a, b) => {
    const left = pick(a)
    const right = pick(b)
    if (left === null && right === null) return 0
    if (left === null) return -1
    if (right === null) return 1
    return Date.parse(left) - Date.parse(right)
  }
}
